import { ledgerApi } from '../../../api';
import type { GameStateGetter } from '../types';

export const createMarkWinningsPaid = (get: GameStateGetter) => {
  return async (
    boardId: string,
    userId?: string,
    offlinePlayerId?: string,
    paid: boolean = true
  ): Promise<void> => {
    await ledgerApi.markWinningsPaid(boardId, { userId, offlinePlayerId, paid });
    await get().fetchLedger(boardId);
  };
};
